import { useContext, useEffect, useReducer } from 'react';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import { AppUserContext } from '../../../../global/cnr/contexts/AppUserContext';
import { PapsContext } from '../../../../global/cnr/contexts/PapsContext';
import { labHandlers, labInitialState, labReducer } from '../reducers/LabReducer';
import { ParentContext } from 'global/cnr/contexts/ParentContext';

const LabProvider = () => {

  const parentContext = useContext(ParentContext);
  const { fns } = parentContext ?? {}
  const { database_fns } = fns ?? {}

  // papsContext
  const papsContext = useContext(PapsContext)
  const { paps_state } = papsContext
  const { pathViews } = paps_state ?? {}

  const appUserAccess = useAppUserAccess()
  const { appUserSession } = appUserAccess ?? {}
  const { _itemKey: appUserSessionKey } = appUserSession ?? {}

  const init_state = { pathViews, database_fns }
  const [lab_state, lab_dispatch] = useReducer(labReducer, init_state, labInitialState)
  const lab_handlers = labHandlers(lab_dispatch, lab_state)

  useEffect(() => {
    lab_handlers.handleInit_lab(pathViews)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [appUserSessionKey]);

  return { lab_handlers, lab_state }
};

export default LabProvider
